import {
  auth,
  file,
  user,
  emulation,
  survey,
  timekeeping,
  briefings,
  budgetreport,
  publicbudgetreport,
  department,
  pay,
  revenue,
  dropdowns,
  ioffice,
  portal,
  menu,
  rolegroup,
  employee,
  notification,
  briefingDraft,
  license,
  inform,
  briefingCollection,
  rankingsReport,
  databasefinance,
} from "./modules";

const repositories = {
  files: file,
  auth: auth,
  users: user,
  emulations: emulation,
  surveys: survey,
  timekeepings: timekeeping,
  briefings: briefings,
  budgetreport: budgetreport,
  publicbudgetreport: publicbudgetreport,
  departments: department,
  pays: pay,
  revenues: revenue,
  dropdowns: dropdowns,
  ioffices: ioffice,
  portals: portal,
  menus: menu,
  rolegroups: rolegroup,
  employees: employee,
  notifications: notification,
  briefingDraft: briefingDraft,
  license: license,
  inform: inform,
  briefingCollection: briefingCollection,
  rankingsReport: rankingsReport,
  databasefinance: databasefinance,
};

export default {
  get: (repo) => repositories[repo],
};
